import { motion } from "framer-motion";
import { CARD_BACK } from "../data/cards";
import { SectionTitle, StepShell } from "./Section";
import { Sparkles, Loader2 } from "lucide-react";

const FlipCard = ({ card, position, flipped, index }) => (
  <motion.div
    initial={{ opacity: 0, y: 24 }}
    animate={{ opacity: 1, y: 0 }}
    transition={{ duration: 0.45, delay: index * 0.08 }}
    className="flex flex-col items-center"
  >
    <div className="card3d w-[120px] sm:w-[150px] aspect-[2/3]">
      <div className={`card-inner ${flipped ? "flipped" : ""}`}>
        <div className="card-face card-back-face glow-soft">
          <img src={CARD_BACK} alt="Kartenrückseite" />
        </div>
        <div className="card-face card-front-face glow-soft">
          <img src={card.img} alt={card.name} />
        </div>
      </div>
    </div>
    <span className="serif mt-3 text-[15px] font-semibold text-[#b8860b]">{position}</span>
    {flipped && (
      <motion.span
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.4 }}
        className="text-[15px] text-[#1E3A8A] font-medium"
      >
        {card.name}
      </motion.span>
    )}
  </motion.div>
);

export const CardReveal = ({ cards, positions, flipped, onReveal, loading }) => {
  let footerAction = null;
  if (!flipped) {
    footerAction = (
      <button
        data-testid="reveal-btn"
        onClick={onReveal}
        className="serif text-lg inline-flex items-center gap-2 px-10 py-3.5 rounded-full bg-gradient-to-r from-[#F0C548] to-[#B8860B] text-white glow-soft hover:glow-strong transition-all duration-300"
      >
        <Sparkles size={20} /> Karten aufdecken &amp; Analyse starten
      </button>
    );
  } else if (loading) {
    footerAction = (
      <div data-testid="reading-loading" className="flex flex-col items-center gap-3 text-[#6b4f12]">
        <Loader2 size={34} className="aura-spin text-[#D4AF37]" />
        <span className="serif text-lg">Deine persönliche Analyse wird gelegt...</span>
      </div>
    );
  }

  return (
    <StepShell>
      <SectionTitle kicker="Schritt 5">Deine Karten</SectionTitle>
      <p className="text-center max-w-xl mx-auto -mt-4 mb-10 text-[15px] leading-relaxed text-[#333]">
        Atme tief durch und konzentriere dich auf deine Frage. Wenn du bereit
        bist, decke deine Karten auf.
      </p>

      <div className="flex flex-wrap justify-center gap-5 sm:gap-7">
        {cards.map((c, i) => (
          <FlipCard key={c.id} card={c} position={positions[i]} flipped={flipped} index={i} />
        ))}
      </div>

      <div className="flex justify-center mt-12">{footerAction}</div>
    </StepShell>
  );
};
